/* Coordinate existing helpers without changing consent or app configuration. */
(() => {
  'use strict';
  let scheduled = false;
  let consentRoot;
  let buyButton;
  const buyObserver = new IntersectionObserver(entries => {
    const visible = entries.some(entry => entry.isIntersecting);
    document.body.classList.toggle('dv-conversion-buy-visible', visible);
    schedule();
  });
  const sync = () => {
    scheduled = false;
    const dock = document.querySelector('.dv-compare-dock');
    const slot = document.querySelector('[data-dv-conversion-compare]');
    if (dock && slot && dock.parentElement !== slot) slot.append(dock);
    const currentButton = document.querySelector('.product-form__submit,.cart__checkout-button');
    if (currentButton !== buyButton) {
      buyObserver.disconnect();
      buyButton = currentButton;
      if (buyButton) buyObserver.observe(buyButton);
      else document.body.classList.remove('dv-conversion-buy-visible');
    }

    const cmp = document.querySelector('pandectes-cmp');
    if (cmp?.shadowRoot && consentRoot !== cmp.shadowRoot) {
      consentRoot = cmp.shadowRoot;
      const style = document.createElement('style');
      style.textContent = '.widget.bottom { bottom:calc(var(--float,16px) + var(--dv-purchase-clearance,0px)) !important; }';
      consentRoot.append(style);
      new MutationObserver(schedule).observe(consentRoot, { childList:true, subtree:true, attributes:true, attributeFilter:['class','open','hidden','aria-hidden'] });
    }
    const sticky = document.querySelector('.dv-sticky-cart[data-visible="true"],.dv-sticky-atc[data-visible="true"]');
    const clearance = sticky && matchMedia('(max-width:749px)').matches ? `${Math.ceil(sticky.getBoundingClientRect().height) + 12}px` : '0px';
    if (cmp && cmp.style.getPropertyValue('--dv-purchase-clearance') !== clearance) cmp.style.setProperty('--dv-purchase-clearance',clearance);
    const consentDialog = consentRoot?.querySelector('[role="dialog"],dialog[open]');
    const open = Boolean(consentDialog?.getClientRects().length);
    document.body.classList.toggle('dv-conversion-consent-open', open);
  };
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
  }
  function start() {
    sync();
    new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['data-visible','hidden'] });
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('shopify:section:load',schedule);
    document.addEventListener('click',event => {
      const link = event.target.closest('a.dv-conversion-pack,.dv-conversion-shortcuts a,.dv-empty-state a');
      if (!link || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
      // No search terms, visitor identifiers or external requests are added.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'dv_conversion_navigation',release:'20260917',surface:link.classList.contains('dv-conversion-pack') ? 'pack' : link.closest('.dv-conversion-shortcuts') ? 'menu' : 'recovery',destination:link.getAttribute('href')});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
